<template>
  <ipo3-page>
    <template slot="title">{{$t('titles.ad')}}</template>
    <template slot="tools">
      <el-button icon="el-icon-edit" @click="onCreate" type="primary">{{$t('btns.add')}}</el-button>
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              v-if="item.id==='image'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <img :src="scope.row.image" width="100" height="100" />
              </template>
            </el-table-column>
            <el-table-column
              v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row.id)"
                  size="mini"
                  type="success"
                >編輯</el-button>
                <el-button
                  @click="onDelete(scope.$index, scope.row)"
                  size="mini"
                  type="danger"
                >{{$t('btns.del')}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
      <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="首页新闻" name="1">
          首页新闻
        </el-tab-pane>
        <el-tab-pane label="推荐" name="2">认证信息</el-tab-pane>
      </el-tabs>-->
    </template>
  </ipo3-page>
</template>
<script>
const types = ["首页Cover", "横倒图", "正方图", "左右走图"];
export default {
  name: "home-index",
  data() {
    return {
      activeName: "1",
      tableData: [],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "title" },
        { name: "類別", id: "type" },
        { name: "狀態", id: "status" },
        { name: "時間", id: "create_time" }
      ],
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      var self = this;
      this.$http.get("/admin/banner").then(res => {
        console.log("res:", res);
        let { data } = res.data;
        data.forEach(item => {
          item.name = types[item.type];
        });
        self.tableData = res.data.data;
      });
    },
    onCreate() {
      this.$router.push({ path: "/dashboard/banner-edit" });
    },
    onHandle(index, id) {
      this.$router.push({ path: `/dashboard/banner-edit/${id}` });
    },
     onDelete(index,value)
    {
      var self = this;
      this.$http.post('/admin/banner/delete',{id:value.id}).then(res=>{
          if(res.code==200)
          {
            self.getData();
            self.$message.success("删除成功");
          }else
          {
            self.$message.error(res.msg);
          }
      });
    },
  }
};
</script>